<template>
  <div class="external-data">
    <h2>External Data</h2>
    <div class="external-matches-container">
      <div v-if="externalMatches && externalMatches.length">
        <div
          v-for="(match, index) in externalMatches"
          :key="index"
          class="external-match"
        >
          <table>
            <tbody>
              <tr>
                <td class="external-key">Link</td>
                <td class="external-value">
                  <a :href="match.link || '#'" target="_blank">{{ match.link || 'N/A' }}</a>
                </td>
              </tr>
              <tr>
                <td class="external-key">Price</td>
                <td class="external-value">{{ match.price || 'N/A' }}</td>
              </tr>
              <tr>
                <td class="external-key">Material</td>
                <td class="external-value">
                  <span v-if="Array.isArray(match.material) && match.material.length">
                    {{ match.material.join(', ') }}
                  </span>
                  <span v-else-if="match.material">{{ match.material }}</span>
                  <span v-else>N/A</span>
                </td>
              </tr>
              <tr>
                <td class="external-key">Care Instructions</td>
                <td class="external-value">
                  <span v-if="Array.isArray(match.care_instructions) && match.care_instructions.length">
                    {{ match.care_instructions.join(', ') }}
                  </span>
                  <span v-else-if="match.care_instructions">{{ match.care_instructions }}</span>
                  <span v-else>N/A</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else>
        <p class="no-data">No external data available.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExternalData',
  props: {
    externalMatches: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.external-data {
  padding: 20px;
}

.external-data h2 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--secondary-color);
}

.external-matches-container {
  max-height: 300px; /* Adjust as needed */
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
}

.external-match {
  margin-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 10px;
}

.external-data table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.external-key {
  text-align: left;
  padding: 12px;
  background-color: #f9fafb;
  font-weight: 600;
  width: 35%;
  border-bottom: 1px solid #e5e7eb;
  word-wrap: break-word;
}

.external-value {
  text-align: left;
  padding: 12px;
  background-color: #fff;
  border-bottom: 1px solid #e5e7eb;
  word-wrap: break-word;
}

.external-value a {
  color: var(--primary-color);
  text-decoration: underline;
}

.no-data {
  font-size: 16px;
  color: #7f8c8d;
  text-align: center;
}
</style>
